import { description, designation, hiText } from "./constants";
import { AboutContainer, Description, Designation, HiText } from "./styles";

export default function About(){
    return (
        <AboutContainer id="ABOUT">
            <HiText>{hiText}</HiText>
            <Designation>{designation}</Designation>
            <Description>{description}</Description>
        </AboutContainer>
    );
}